export const ActionTypes = {
    FETCH_LANGUAGE_REQUEST:"FETCH_LANGUAGE_REQUEST",
    FETCH_LANGUAGE_SUCCESS:"FETCH_LANGUAGE_SUCCESS",
    FETCH_LANGUAGE_FAIL:"FETCH_LANGUAGE_FAIL",
    FETCH_LANG_CODE:"FETCH_LANG_CODE",
}